import { Component, Input, ContentChild } from '@angular/core';
import { TabContentDirective } from './tab-content.directive';
import { TabTitleDirective } from './tab-title.directive';


export class ChTabComponent {
   id: string;
   title: string;
   disabled: boolean | string = false;
   contentTpl: TabContentDirective;
   titleTpl: TabTitleDirective;
  constructor() {}

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ch-tab',
  template: ''
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'title': [{ type: Input },],
'disabled': [{ type: Input },],
'contentTpl': [{ type: ContentChild, args: [TabContentDirective, ] },],
'titleTpl': [{ type: ContentChild, args: [TabTitleDirective, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
